import {Component, Injector, OnInit} from '@angular/core';
import {RetroalimentacionService} from '../_services/retroalimentacion.service';

@Component({
  selector: 'dashboard-retroalimentacion-barra',
  standalone: false,
  templateUrl: 'dashboard-retroalimentacion-barra.component.html'
})

export class DashboardRetroalimentacionBarraComponent implements OnInit {

  materia: any;


  constructor(private injector: Injector,
              private retroalimentacionService: RetroalimentacionService) {
  }

  ngOnInit() {
    this.materia = this.injector.get('materia');
  }
}
